module.exports = __webpack_public_path__ + "img/head-banner4.7bbd0c54.jpg";